import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "./monitoring";

/** Catches a crash while rendering, reports it, and offers a reload instead of leaving a blank page. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    reportError(error, { componentStack: info.componentStack ?? undefined });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="center-msg">
        <div className="stack" style={{ justifyItems: "center", textAlign: "center" }}>
          <p>Something went wrong showing this page.</p>
          <button type="button" className="btn btn-primary" onClick={() => location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}
